import SignupValidationAPI from '../../APIs/SignupAPI/SignupValidationAPI'

export const validationOneTwo = {
    state: {
        getValidationOne: '',
        getValidationTwo: '',
        accntName: '',
        membCode: '',
        birthday: '',
        status: ''
    },
    actions: {
        async validationOneTwo({ commit }, signupCredentials) {
            commit('DISPLAY_MEMBCODE_BIRTHDAY', {
                MEMBCODE: signupCredentials.MEMBCODE,
                BIRTHDAY: signupCredentials.BDAY
            })
            await SignupValidationAPI.validationOneTwo(signupCredentials)
                .then(res => {
                    // VALIDATION 1
                    if (
                        signupCredentials.MEMBCODE == '' ||
                        signupCredentials.BDAY == '' ||
                        res.data.data == ''
                    ) {
                        // tl.to(".radioBtns", 0.3, {
                        //   opacity: 0,
                        //   pointerEvents: "none",
                        // });
                        commit('VALIDATION_ONE', res.data.NO_RECORD)
                    }

                    // VALIDATION 2
                    else if (
                        res.data.STATUS == 'INACTIVE' ||
                        res.data.STATUS == 'LATE RENEWAL' ||
                        res.data.STATUS == 'REINSTATEMENT' ||
                        res.data.STATUS == 'MEDICAL EVALUATION' ||
                        res.data.STATUS == 'WAIVER' ||
                        res.data.STATUS == 'REAPPLICATION' ||
                        res.data.STATUS == 'CANCELLED'
                    ) {
                        // tl.to(".radioBtns", 0.3, {
                        //   opacity: 0,
                        //   pointerEvents: "none",
                        // });
                        commit('VALIDATION_ONE', res.data.NO_RECORD)
                        commit('VALIDATION_TWO', res.data.STATUS_MESSAGE)
                    }

                    // DISPLAY ACCOUNT NAME
                    else {
                        // tl.to(".radioBtns", 0.3, {
                        //   opacity: 1,
                        //   pointerEvents: "all",
                        // });
                        commit('VALIDATION_ONE', '')
                        commit('VALIDATION_TWO', '')
                        commit('DISPLAY_ACCNT_NAME', res.data.ACCNT_NAME)
                        commit('GET_ACCOUNT_STATUS', res.data)
                    }
                    window.grecaptcha.reset()
                })
                .catch(error => {
                    // VALIDATION 1
                    if (
                        signupCredentials.MEMBCODE == '' ||
                        signupCredentials.BDAY == '' ||
                        error.response.data.data == ''
                    ) {
                        // tl.to(".radioBtns", 0.3, {
                        //   opacity: 0,
                        //   pointerEvents: "none",
                        // });
                        commit('VALIDATION_ONE', error.response.data.NO_RECORD)
                    }

                    // VALIDATION 2
                    else if (
                        error.response.data.STATUS == 'INACTIVE' ||
                        error.response.data.STATUS == 'LATE RENEWAL' ||
                        error.response.data.STATUS == 'REINSTATEMENT' ||
                        error.response.data.STATUS == 'MEDICAL EVALUATION' ||
                        error.response.data.STATUS == 'WAIVER' ||
                        error.response.data.STATUS == 'REAPPLICATION' ||
                        error.response.data.STATUS == 'CANCELLED'
                    ) {
                        // tl.to(".radioBtns", 0.3, {
                        //   opacity: 0,
                        //   pointerEvents: "none",
                        // });

                        commit('VALIDATION_TWO', error.response.data.STATUS_MESSAGE)
                    }

                    // DISPLAY ACCOUNT NAME
                    else {
                        // tl.to(".radioBtns", 0.3, {
                        //   opacity: 1,
                        //   pointerEvents: "all",
                        // });

                        commit('VALIDATION_ONE', '')
                        commit('DISPLAY_ACCNT_NAME', error.response.data.ACCNT_NAME)
                        commit('GET_ACCOUNT_STATUS', error.response.data.STATUS)
                    }
                    window.grecaptcha.reset()
                })
        }
    },
    mutations: {
        VALIDATION_ONE(state, getValidationOne) {
            state.getValidationOne = getValidationOne
        },
        VALIDATION_TWO(state, getValidationTwo) {
            state.getValidationTwo = getValidationTwo
        },
        DISPLAY_ACCNT_NAME(state, accntName) {
            state.accntName = accntName
        },
        DISPLAY_MEMBCODE_BIRTHDAY(state, signupCredentials) {
            state.membCode = signupCredentials.MEMBCODE
            state.birthday = signupCredentials.BIRTHDAY
        },
        GET_ACCOUNT_STATUS(state, status) {
            state.status = status
        },
        RESET_VAL_ONE_TWO(state, param) {
            state.getValidationOne = param
            state.getValidationTwo = param
            state.accntName = param
            state.membCode = param
            state.birthday = param
            state.status = param
        }
    },
    getters: {
        getValidationOne(state) {
            return state.getValidationOne
        },
        getValidationTwo(state) {
            return state.getValidationTwo
        },
        displayAccountName(state) {
            return state.accntName
        },

        // GET MEMBCODE AND BIRTHDATE FOR CREATE FORM DISPLAY
        getMembcode(state) {
            return state.membCode
        },
        getBirthdate(state) {
            return state.birthday
        },
        getStatus(state) {
            return state.status
        }
    }
}
